/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-score-box',
  templateUrl: './score-box.component.html',
  styleUrls: ['./score-box.component.scss'],
})
export class ScoreBoxComponent {
  @Input() isLoading = false;
  @Input() isFocused = false;
  @Input() scoreName: string;
  @Input() scoreValue: number | string;
  @Input() scoreData: any;
  @Input() scoreColor: string;
  @Input() scoreEventsCount: number;
  @Input() scoreEventsTimeframe: number | string;
  @Input() scoreType: 'sentiment' | 'score' | 'bb' | 'flag';
  @Input() flagType: 'warning' | 'caution';
  @Input() iconSrc: string;
  @Input() scoreScaleType: 'pos' | 'neg' = 'neg';

  @Output() scoreClick: EventEmitter<void> = new EventEmitter<void>();

  mouseOverAlert = false;

  onScoreClick() {
    this.scoreClick.emit();
  }
}
